export const personalDetailsFiles = {
  passport: 'Passport',
};
